import { codetableAdministrationTranslation } from 'app/area/codetable/constants';

export enum RiskMatrixIds {
  riskMatrixType = 'riskMatrixType'
}

export enum RiskMatrixSortOrderType {
  ascending = 1,
  descending = 2
}

export const compactModeThreshold = 4;

export const riskMatrixTranslation = {
  ...codetableAdministrationTranslation,

  update_risk_matrix: 8949,
  risk_matrix_used_for: 8950,
  risk_matrix_type: 8951,
  risk_matrix_saved_successfully: 8952,
  weight: 8953,
  risk_area: 8954,
  recurrence_frequency: 8787,
  choosing_type_is_required: 8979,
  no_risk_matrix_data_for_type: 8991,
  risk_matrix_label_info_text: 9000,
  third_axis_label_info_text: 9001,
  case_type_not_used: 9002,
  risk_matrix_label_info_text_mobile: 9005,
  third_axis_label_info_text_mobile: 9006
};

export type RiskMatrixTranslation = {
  readonly [T in keyof typeof riskMatrixTranslation]: string
};

export const consequencesAndLostPotentialCodetableId = 1061;

export const mdResolution = 770;

export const matrixRowHeight = 60;
